export const RULE_AREAS = ["cohort", "sample", "blocklist"] as const;

export type RuleArea = (typeof RULE_AREAS)[number];
